import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swap_horiz",
  "use": "icon-swap_horiz-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol viewBox=\"0 0 49 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-swap_horiz\"><path d=\"M14.2461 39.3077L5.19235 30.2539L14.2461 21.2001L15.8461 22.8L9.50765 29.1193H25.6346V31.3885H9.50765L15.8461 37.7077L14.2461 39.3077ZM34.7539 26.8L33.1539 25.2L39.4923 18.8808H23.3654V16.6116H39.4923L33.1539 10.2731L34.7539 8.69238L43.8077 17.7462L34.7539 26.8Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol